import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { getItemLinkFieldValue } from '@core/jss-utils';
import { InnogyComponentRendering } from '@core/jss-models';
import { NgClass } from '@angular/common';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'wl-marketing-heading',
  templateUrl: './marketing-heading.component.html',
  styleUrls: [
    './marketing-heading.component.ed.scss',
    './marketing-heading.component.essent.scss',
  ],
  standalone: true,
  imports: [NgClass, JssModule],
})
export class MarketingHeadingComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  theme = '';

  ngOnInit() {
    if (this.rendering && this.rendering.fields) {
      const themeValue = getItemLinkFieldValue(this.rendering.fields, 'Theme');
      this.theme = themeValue ? `--${themeValue}` : '';
    }
  }
}
